import React from 'react';
import { formatCodeAmount } from '../../utils/analytics';

const TopBilledGroupsBody = ({ groups = [] }) => {
  if (groups.length === 0) {
    return <span className="top-billed-groups__empty">No billed groups</span>;
  }

  return (
    <div className="top-billed-groups">
      <div className="top-billed-groups__rows">
        {groups.map((group) => (
          <div key={group.referenceId} className="top-billed-groups__row">
            <span className="top-billed-groups__name">{group.referenceId}</span>
            <span className="top-billed-groups__amount">{formatCodeAmount(group.totalAmount)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopBilledGroupsBody;
